<template>
  <QuesStarRating
    v-if="showQues(QType.RATING)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesSlider
    v-else-if="showQues(QType.SLIDER)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesText
    v-else-if="showQues(QType.TEXT)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesNumeric
    v-else-if="showQues(QType.NUMERIC)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesChoiceMultiple
    v-else-if="showQues(QType.CHOICE_MULTIPLE)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <!-- get pageType info -->
  <QuesChoice
    v-else-if="showQues(QType.CHOICE)"
    :ques="ques"
    :isEdit="isEdit"
    :pageType="pageType"
    @quesDel="$emit('quesDel')"
  />
  <QuesDate
    v-else-if="showQues(QType.DATE)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesDateTime
    v-else-if="showQues(QType.DATE_TIME)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesMatrix
    v-else-if="showQues(QType.MATRIX)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <QuesFile
    v-else-if="showQues(QType.FILE)"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  />
  <div v-else>未知題型</div>
</template>

<script>
import QuesStarRating from '../components/QuesStarRating'
import QuesSlider from '../components/QuesSlider'
import QuesText from '../components/QuesText'
import QuesNumeric from '../components/QuesNumeric'
import QuesChoice from '../components/QuesChoice'
import QuesChoiceMultiple from '../components/QuesChoiceMultiple'
import QuesDate from '../components/QuesDate'
import QuesMatrix from '../components/QuesMatrix'
import QuesDateTime from '../components/QuesDateTime'
import QuesFile from '../components/QuesFile'
export default {
  components: {
    QuesStarRating,
    QuesSlider,
    QuesText,
    QuesChoice,
    QuesNumeric,
    QuesChoiceMultiple,
    QuesDate,
    QuesDateTime,
    QuesMatrix,
    QuesFile,
  },
  props: {
    // get pageType info
    pageType: {
      type: String,
      default: null,
    },
    // 是否正在編輯，如果正在編輯就改顯示編輯元件
    isEdit: {
      type: Boolean,
      default: false,
    },
    // 題目本人
    ques: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    QType() {
      return this.$store.state.QType
    },
  },
  methods: {
    showQues(qtype) {
      // window.console.log(this.ques.questItemType)
      // window.console.log(qtype.name)
      return this.ques.questItemType === qtype.name
    },
  },
}
</script>

<style lang="scss" scoped></style>
